import "../styling/loading.css";

function Loading() {
  return (
    <div className="syncwave-loader-container">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  );
}

export default Loading;
